import styled from 'styled-components';

const Hr = styled.hr`
margin: 37px 0 42px 0
`;

export {
    Hr
}